import intl from 'react-intl-universal';
import {
  caseTitleColumn,
  deadlineColumn,
  orderTimeColumn,
  returnedTimeColumn,
  stateColumn,
  viewColumn,
} from '../commonColumns';
import { Chip, Stack, Typography } from '@mui/material';
import Emergency from 'components/DataTable/Emergency';
import {
  IssueStatus,
  IssuePriority,
  IssueStatusToOrder,
  getIssueStatus,
} from 'shared/constants/issues';
import { Status } from 'components/Status/styles';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('ReceivedHistoryTableColumns');

export const receivedStatusColumn = (filterSelectOptions) => ({
  accessorKey: 'status',
  header: intl.get('case_list_label_column_status'),
  filterVariant: 'select',
  enableSorting: true,
  enableFacetedValues: false,
  sortingFn: (rowA, rowB, columnId) => {
    const order1 = IssueStatusToOrder[rowA.getValue(columnId)];
    const order2 = IssueStatusToOrder[rowB.getValue(columnId)];
    return order1 === order2 ? 0 : order1 > order2 ? 1 : -1;
  },
  filterSelectOptions: filterSelectOptions,
  Cell: receivedStatusCell,
});

export const getReceivedTableColumns = (handleOpenIssueDetails) => [
  caseTitleColumn(),
  receivedStatusColumn([
    {
      label: intl.get('shared_value_status_new_task'),
      value: IssueStatus.NEWTASK,
    },
    {
      label: intl.get('shared_value_status_check_ready'),
      value: IssueStatus.CHECKREADY,
    },
    {
      label: intl.get('shared_value_status_doctor_assigned'),
      value: IssueStatus.DOCTORASSIGNED,
    },
    {
      label: intl.get('shared_value_status_report_ready'),
      value: IssueStatus.REPORTREADY,
    },
    {
      label: intl.get('shared_value_status_send_back_receiver'),
      value: IssueStatus.SENDBACK,
    },
    {
      label: intl.get('shared_value_status_done_receiver'),
      value: IssueStatus.DONE,
    },
  ]),
  stateColumn(),
  {
    accessorKey: 'emergency',
    header: intl.get('case_list_label_column_emergency'),
    filterVariant: 'multi-select',
    enableFacetedValues: false,
    Cell: emergencyCell,
    filterSelectOptions: [
      {
        label: intl.get('shared_value_priority_low'),
        value: IssuePriority.LOW,
      },
      {
        label: intl.get('shared_value_priority_medium'),
        value: IssuePriority.MEDIUM,
      },
      {
        label: intl.get('shared_value_priority_high'),
        value: IssuePriority.HIGH,
      },
    ],
  },
  orderTimeColumn(),
  returnedTimeColumn(),
  deadlineColumn(),
  {
    accessorKey: 'from',
    header: intl.get('case_list_label_column_from'),
    filterVariant: 'multi-select',
    enableFacetedValues: true,
  },
  {
    accessorKey: 'doctor',
    header: intl.get('case_list_label_column_doctor_in_charge'),
    enableSorting: false,
    filterVariant: 'multi-select',
    enableFacetedValues: true,
    Cell: doctorCell,
  },
  viewColumn(handleOpenIssueDetails),
];

const emergencyCell = ({ renderedCellValue }) => {
  return <Emergency priority={renderedCellValue} />;
};

emergencyCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
};

const doctorCell = ({ renderedCellValue }) => {
  const doctorList = renderedCellValue;
  if (
    doctorList.length === 1 &&
    doctorList[0] === intl.get('case_list_value_doctor_unassigned')
  ) {
    return (
      <Typography variant="body2" style={{ wordWrap: 'break-word' }}>
        {intl.get('case_list_value_doctor_unassigned')}
      </Typography>
    );
  }
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 1 }}>
      {doctorList.map((doctor) => (
        <Chip label={doctor} key={doctor} />
      ))}
    </Stack>
  );
};

doctorCell.propTypes = {
  renderedCellValue: PropTypes.array.isRequired,
};

const receivedStatusCell = ({ row }) => {
  const statusValue = row.getValue('status');
  return <Status color={statusValue}>{getIssueStatus(statusValue)}</Status>;
};

receivedStatusCell.propTypes = {
  row: PropTypes.object.isRequired,
};
